import React, { useState } from "react";
import { getFilesToUpload } from "@microdoing/shared/services/upload/selectors";
import { Box, MainText, PressableOpacity } from "app/components/common";
import { useSelector } from "react-redux";
import i18n from "@microdoing/shared/i18n";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import AudioMessage from "app/scenes/MessageScreen/ChatScreen/AudioMessage";
import * as Progress from "react-native-progress";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import FastImage from "react-native-fast-image";

const MicroImage = require("../../../../../assets/images/Micro.png");

const ICON_WIDTH = normalize(19);

export interface IAudioAnalysisProps {}

const AudioAnalysis = ({}: IAudioAnalysisProps) => {
  const [width, setWidth] = useState(0);

  const isFocused = useIsFocused();

  const files = useSelector(getFilesToUpload);
  const audioFile = files?.[files?.length - 1];

  const navigation = useNavigation();

  const handleOnLayout = event => {
    const { width } = event.nativeEvent.layout;
    setWidth(width);
  };

  const onClickModify = () => {
    navigation.navigate("ReflexiveAnalysisScreen");
  };

  const { uploadProgress = 0 } = audioFile || {};

  return (
    <Box flex={1}>
      <Box flexDirection="row" alignItems="center" marginBottom="m">
        <FastImage
          style={{ height: ICON_WIDTH, width: ICON_WIDTH }}
          source={MicroImage}
        />
        <MainText
          variant="l3-medium"
          color="neutral.900"
          marginRight="xs"
          marginLeft="xs"
        >
          {i18n.t("recap-feedback-audio")}
        </MainText>
        <PressableOpacity onPress={onClickModify}>
          <MainText variant="l2-medium" color="brand.500">
            {i18n.t("modify")}
          </MainText>
        </PressableOpacity>
      </Box>
      <Box marginBottom="sm" onLayout={handleOnLayout}>
        {!!audioFile && isFocused && (
          <AudioMessage
            soundUrl={audioFile?.audioFileURL || audioFile?.uri}
            hasDarkBackground={false}
          />
        )}
        {uploadProgress > 0 && (
          <Progress.Bar
            style={{ marginTop: theme.spacing.xs }}
            progress={uploadProgress}
            width={width}
            height={normalize(3)}
            borderRadius={8}
            useNativeDriver
            borderWidth={0}
            color={theme.colors["system.green.900"]}
            unfilledColor={"#ECEBF1"}
          />
        )}
        {uploadProgress > 0 && (
          <MainText marginTop="xs" variant="l1-regular">
            {(uploadProgress * 100).toFixed(0)}%
          </MainText>
        )}
      </Box>
    </Box>
  );
};

export default AudioAnalysis;
